

export function filterDefinedListings<T>(listings: (T & {
  listingId?: number,
  listingCurrencySymbol?: string,
  productId?: number,
  baseTax?: number,
  taxPercent?: number })[])
{
  return listings
    .filter(d =>
      d.listingId !== undefined &&
      d.listingCurrencySymbol !== undefined &&
      d.productId !== undefined)
    .map(d => ({
      ...d,
      listingId: Number(d.listingId),
      listingCurrencySymbol: String(d.listingCurrencySymbol),
      productId: Number(d.productId),
      baseTax: Number(d.baseTax),
      taxPercent: Number(d.taxPercent) }));
}